import { z } from 'zod';

/**
 * A boolean that arrives as a query-string parameter.
 *
 * `z.coerce.boolean()` is FORBIDDEN for this (N7): it applies JavaScript
 * truthiness, so the string `'false'` coerces to `true` and a client asking to
 * exclude something gets the opposite. Only the two exact spellings are
 * accepted; anything else is a 422 rather than a silent misreading.
 */
export const BooleanParamSchema = z.enum(['true', 'false']).transform((value) => value === 'true');

export type BooleanParam = z.infer<typeof BooleanParamSchema>;
